<div class="contents-area">
  <div class="element-column">
    <ng-container *ngIf="model.isBeforeProposing()">
      <button id="btn_Copy" class="btn-secondary" (click)="eventCopy_CLICKHandler()"
        [disabled]="model.disabledSettings.copyProposal">既存商品コピー</button>
    </ng-container>
    <div class="column-list">
      <label class="list-input-title">部門</label>
      <div class="list-input-content">
        <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode" [subid]="'cmb_ClassCode'" class="combo-box-required"
          [tabindex]="0" [blank]="false" [(ngModel)]="model.newGoodsProposal.classCode"
          (ngModelChange)="eventClassCode_CHANGEHandler()" [required]="true" [style.width.px]="205"
          [disabled]="model.disabledSettings.classCode">
        </app-class-code-combo-box>
      </div>
      <label class="list-input-title">商品担当者</label>
      <div class="list-input-content">
        <select id="cmb_BuyerUserId" class="combo-box-required" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.buyerUserId" [style.width.px]="205"
          [disabled]="model.disabledSettings.buyerUserId">
          <ng-template ngFor let-item [ngForOf]="model.buyerList">
            <option value="{{item.UserId}}">{{item.UserNmKanji}}</option>
          </ng-template>
        </select>
      </div>
      <label class="list-input-title">商品名</label>
      <div class="list-input-content">
        <app-not-null-text-input id="txti_GoodsName" [subid]="'txti_GoodsName'" [fullOnly]="true" [maxChars]="30"
          [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false" [(ngModel)]="model.newGoodsProposal.goodsName"
          width="32rem" [disabled]="model.disabledSettings.goodsName" (blur)="eventGoodsName_FOCUS_OUTHandler()">
        </app-not-null-text-input>
      </div>
      <label class="list-input-title">規格名</label>
      <div class="list-input-content">
        <app-not-null-text-input id="txti_StandardName" [subid]="'txti_StandardName'" [fullOnly]="true" [maxChars]="15"
          [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false"
          [(ngModel)]="model.newGoodsProposal.standardName" width="17rem"
          [disabled]="model.disabledSettings.standardName" (blur)="eventStandardName_FOCUS_OUTHandler()">
        </app-not-null-text-input>
      </div>
      <label class="list-input-title">JANコード</label>
      <div class="list-input-content">
        <input type="text" id="txti_JanCode" [maxlength]="13" [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'"
          enabled="true" [(ngModel)]="model.newGoodsProposal.janCode" [disabled]="model.disabledSettings.janCode"
          [style.width.rem]="10" (blur)="eventJanCode_FOCUS_OUTHandler()"/>
      </div>
      <label class="list-input-title">セールスポイント</label>
      <div class="list-input-content">
        <app-text-input id="txti_SalesPoint" [subid]="'txti_SalesPoint'" [fullOnly]="true" [maxChars]="30"
          [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false" [(ngModel)]="model.newGoodsProposal.salesPoint"
          width="32rem" [disabled]="model.disabledSettings.salesPoint">
        </app-text-input>
      </div>

      <label class="list-input-title" style="visibility:hidden;"></label>
      <div class="element-row price-label">
        <p>通常</p>
        <p>特１</p>
        <p>特２</p>
      </div>
      <label class="list-input-title">希望価格（売価）</label>
      <div class="list-input-content">
        <div class="element-row">
          <input type="text" id="txti_StandardSellingPrice" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7"
            [tabindex]="0" [(ngModel)]="model.newGoodsProposal.standardSellingPrice"
            (change)="eventStandardPrice_CHANGEHandler()" [style.width.rem]="7"
            [disabled]="model.disabledSettings.standardSellingPrice" />
          <input type="text" id="txti_Special1SellingPrice" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7"
            [tabindex]="0" [(ngModel)]="model.newGoodsProposal.special1SellingPrice"
            (change)="eventSpecial1Price_CHANGEHandler()" [style.width.rem]="7"
            [disabled]="model.disabledSettings.special1SellingPrice" />
          <input type="text" id="txti_Special2SellingPrice" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7"
            [tabindex]="0" [(ngModel)]="model.newGoodsProposal.special2SellingPrice"
            (change)="eventSpecial2Price_CHANGEHandler()" [style.width.rem]="7"
            [disabled]="model.disabledSettings.special2SellingPrice" />
        </div>
      </div>
      <label class="list-input-title">希望価格（仕入価）</label>
      <div class="list-input-content">
        <div class="element-row">
          <input type="text" id="txti_StandardCostPrice" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10"
            [tabindex]="0" [(ngModel)]="model.newGoodsProposal.standardCostPrice"
            (change)="eventStandardPrice_CHANGEHandler()" [style.width.rem]="7"
            [disabled]="model.disabledSettings.standardCostPrice" />
          <input type="text" id="txti_Special1CostPrice" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10"
            [tabindex]="0" [(ngModel)]="model.newGoodsProposal.special1CostPrice"
            (change)="eventSpecial1Price_CHANGEHandler()" [style.width.rem]="7"
            [disabled]="model.disabledSettings.special1CostPrice" />
          <input type="text" id="txti_Special2CostPrice" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10"
            [tabindex]="0" [(ngModel)]="model.newGoodsProposal.special2CostPrice"
            (change)="eventSpecial2Price_CHANGEHandler()" [style.width.rem]="7"
            [disabled]="model.disabledSettings.special2CostPrice" />
        </div>
      </div>
      <label class="list-input-title">GPR</label>
      <div class="list-input-content">
        <div class="element-row">
          <input type="text" [value]="model.newGoodsProposal.standardGpr" [style.width.rem]="7" readonly />
          <input type="text" [value]="model.newGoodsProposal.special1Gpr" [style.width.rem]="7" readonly />
          <input type="text" [value]="model.newGoodsProposal.special2Gpr" [style.width.rem]="7" readonly />
        </div>
      </div>

      <label class="list-input-title">消費期限</label>
      <div class="list-input-content">
        <input type="text" id="txti_ExpirationDate" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4"
          [tabindex]="0" [(ngModel)]="model.newGoodsProposal.expirationDate" [style.width.rem]="4"
          [disabled]="model.disabledSettings.expirationDate" />
      </div>
      <label class="list-input-title">賞味期間</label>
      <div class="list-input-content">
        <input type="text" id="txti_BestBeforeDate" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4"
          [tabindex]="0" [(ngModel)]="model.newGoodsProposal.bestBeforeDate" [style.width.rem]="4"
          [disabled]="model.disabledSettings.bestBeforeDate" />
      </div>

      <label class="list-input-title">展開開始希望受注コード</label>
      <div class="list-input-content">
        <app-order-text-with-catalog id="cmb_PreferredStartOrderCode" [subid]="'cmb_PreferredStartOrderCode'"
          [autofocus]="true" [tabindex]="0" [(ngModel)]="model.newGoodsProposal.preferredOrderCode"
          (onChangedCatalogId)="model.newGoodsProposal.preferredDelivCatalogId = $event" [forcedEnabledMode]="''"
          width="80" [disabled]="model.disabledSettings.preferredOrderCode">
        </app-order-text-with-catalog>
      </div>
      <label class="list-input-title">展開開始希望企画回</label>
      <div class="list-input-content">
        <app-catalog-text-with-order id="cmb_PreferredStartDelivCatalogId" [subid]="'cmb_PreferredStartDelivCatalogId'"
          [autofocus]="true" [tabindex]="0" [(ngModel)]="model.newGoodsProposal.preferredDelivCatalogId"
          (onChangedOrderCode)="model.newGoodsProposal.preferredOrderCode = $event" [forcedEnabledMode]="''" width="80"
          [disabled]="model.disabledSettings.preferredDelivCatalogId">
        </app-catalog-text-with-order>
      </div>
      <label class="list-input-title">希望展開区分</label>
      <div class="list-input-content expansion-div">
        <app-radio-label id="rdb_PrefferedExpansionDiv1" [subid]="'rdb_PrefferedExpansionDiv1'"
          name="rdb_PrefferedExpansionDiv" label="毎週" value="1"
          [(ngModel)]="model.newGoodsProposal.preferredExpansionDiv"
          (change)="eventPrefferedExpansionDiv_CHANGEHandler()" [tabindex]="0"
          [disabled]="model.disabledSettings.preferredExpansionDiv1">
        </app-radio-label>
        <app-radio-label id="rdb_PrefferedExpansionDiv2" [subid]="'rdb_PrefferedExpansionDiv2'"
          name="rdb_PrefferedExpansionDiv" label="中1週" value="2"
          [(ngModel)]="model.newGoodsProposal.preferredExpansionDiv"
          (change)="eventPrefferedExpansionDiv_CHANGEHandler()" [tabindex]="0"
          [disabled]="model.disabledSettings.preferredExpansionDiv2">
        </app-radio-label>
        <app-radio-label id="rdb_PrefferedExpansionDiv3" [subid]="'rdb_PrefferedExpansionDiv3'"
          name="rdb_PrefferedExpansionDiv" label="中3週" value="3"
          [(ngModel)]="model.newGoodsProposal.preferredExpansionDiv"
          (change)="eventPrefferedExpansionDiv_CHANGEHandler()" [tabindex]="0"
          [disabled]="model.disabledSettings.preferredExpansionDiv3">
        </app-radio-label>
        <div class="expansion-div-other">
          <app-radio-label id="rdb_PrefferedExpansionDiv4" [subid]="'rdb_PrefferedExpansionDiv4'"
            name="rdb_PrefferedExpansionDiv" label="その他：" value="4"
            [(ngModel)]="model.newGoodsProposal.preferredExpansionDiv" [tabindex]="0"
            [disabled]="model.disabledSettings.preferredExpansionDiv4">
          </app-radio-label>
          <app-not-null-text-input id="tbx_Other" [subid]="'tbx_Other'" [fullOnly]="true" [maxChars]="30" [restrict]="'[ -￮]'"
            [tabindex]="0" [displayCountField]="false" [(ngModel)]="model.newGoodsProposal.preferredExpansionOther" width="32rem"
            [disabled]="model.disabledSettings.preferredExpansionOther || model.newGoodsProposal.preferredExpansionDiv!=='4'">
          </app-not-null-text-input>
        </div>
      </div>
      <label class="list-input-title">展開可能生協</label>
      <div class="list-input-content">
        <app-checkbox-label id="chk_AllCoop" [subid]="'chk_AllCoop'" label="ALL" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.allCoop" (change)="eventAllCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.allCoop">
        </app-checkbox-label>
        <app-checkbox-label id="chk_Ibaraki" [subid]="'chk_Ibaraki'" label="い" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.expandableCoop.ibaraki" (change)="eventCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.ibaraki">
        </app-checkbox-label>
        <app-checkbox-label id="chk_Tochigi" [subid]="'chk_Tochigi'" label="と" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.expandableCoop.tochigi" (change)="eventCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.tochigi">
        </app-checkbox-label>
        <app-checkbox-label id="chk_Gunma" [subid]="'chk_Gunma'" label="ぐ" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.expandableCoop.gunma" (change)="eventCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.gunma">
        </app-checkbox-label>
        <app-checkbox-label id="chk_Chiba" [subid]="'chk_Chiba'" label="ち" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.expandableCoop.chiba" (change)="eventCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.chiba">
        </app-checkbox-label>
        <app-checkbox-label id="chk_Saitama" [subid]="'chk_Saitama'" label="さ" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.expandableCoop.saitama" (change)="eventCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.saitama">
        </app-checkbox-label>
        <app-checkbox-label id="chk_Tokyo" [subid]="'chk_Tokyo'" label="とう" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.expandableCoop.tokyo" (change)="eventCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.tokyo">
        </app-checkbox-label>
        <app-checkbox-label id="chk_Nagano" [subid]="'chk_Nagano'" label="な" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.expandableCoop.nagano" (change)="eventCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.nagano">
        </app-checkbox-label>
        <app-checkbox-label id="chk_Niigata" [subid]="'chk_Niigata'" label="に" [tabindex]="0"
          [(ngModel)]="model.newGoodsProposal.expandableCoop.niigata" (change)="eventCoop_CHANGEHandler()"
          [disabled]="model.disabledSettings.niigata">
        </app-checkbox-label>
      </div>
      <label class="list-input-title">月齢</label>
      <div class="list-input-content">
        <app-text-area id="txb_MonthAge" [subid]="'txb_MonthAge'" [restrict]="'[ -￮]'" [displayCountField]="true"
          [maxChars]="200" [tabindex]="0" [fullOnly]="true" [(ngModel)]="model.newGoodsProposal.monthAge"
          [disabled]="model.disabledSettings.monthAge" [counterWidth]="'75px'">
        </app-text-area>
      </div>
      <label class="list-input-title">生産工場</label>
      <div class="list-input-content">
        <app-text-input id="tbx_ProductionFactory" [subid]="'tbx_ProductionFactory'" [fullOnly]="true" [maxChars]="30"
          [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false"
          [(ngModel)]="model.newGoodsProposal.productionFactory" width="32rem"
          [disabled]="model.disabledSettings.productionFactory">
        </app-text-input>
      </div>
      <label class="list-input-title">製造工場（新規or既存）</label>
      <div class="list-input-content">
        <app-code-combo-box #cmb_ManufacturingFactory id="cmb_ManufacturingFactory" [subid]="'cmb_ManufacturingFactory'"
          [codeDiv]="'ctp268'" [labelField]="'codeValueName'" [(ngModel)]="model.newGoodsProposal.manufacturingFactory"
          [tabindex]="0" [blank]="true" [style.width.rem]="8"
          [disabled]="model.disabledSettings.manufacturingFactory"></app-code-combo-box>
      </div>
    </div>
    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title">デリ商品基準チェック</label>
        <div class="list-input-content">
          <label><input id="chk_DeliGoodsChecked" type="checkbox" [(ngModel)]="model.newGoodsProposal.deliGoodsChecked"
            [tabindex]="0" [disabled]="model.disabledSettings.deliGoodsChecked"/>済</label>
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title">商品基準チェック依頼</label>
        <div class="list-input-content">
          <label><input type="checkbox" id="chk_GoodsCheckRequest" [(ngModel)]="model.newGoodsProposal.goodsCheckRequest"
            [tabindex]="0" [disabled]="model.disabledSettings.goodsCheckRequest"/>依頼済</label>
        </div>
      </div>
    </div>
    <div class="column-list">
      <label class="list-input-title">温度区分</label>
      <div class="list-input-content">
        <app-code-combo-box #cmb_TemperatureDiv id="cmb_TemperatureDiv" [subid]="'cmb_TemperatureDiv'"
          [codeDiv]="'ct061'" [labelField]="'codeValueName'" [(ngModel)]="model.newGoodsProposal.temperatureDiv"
          [tabindex]="0" [blank]="true" [style.width.rem]="8"
          [disabled]="model.disabledSettings.temperatureDiv"></app-code-combo-box>
      </div>
      <label class="list-input-title">発注先名</label>
      <div class="list-input-content">
        <app-text-input id="txti_orderClientName" [subid]="'txti_orderClientName'" [fullOnly]="true" [maxChars]="30"
          [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false"
          [(ngModel)]="model.newGoodsProposal.orderClientName" width="32rem"
          [disabled]="model.disabledSettings.orderClientName">
        </app-text-input>
      </div>
      <label class="list-input-title">メーカー名</label>
      <div class="list-input-content">
        <app-text-input id="txti_MarkerName" [subid]="'txti_MarkerName'" [fullOnly]="true" [maxChars]="20"
          [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false" [(ngModel)]="model.newGoodsProposal.markerName"
          width="22rem" [disabled]="model.disabledSettings.markerName">
        </app-text-input>
      </div>
      <label class="list-input-title">アレルゲン</label>
      <div class="list-input-content">
        <app-text-area id="txb_Allergen" [subid]="'txb_Allergen'" [restrict]="'[ -￮]'" [displayCountField]="true"
          [maxChars]="200" [tabindex]="0" [fullOnly]="true" [(ngModel)]="model.newGoodsProposal.allergen"
          [disabled]="model.disabledSettings.allergen" [counterWidth]="'75px'">
        </app-text-area>
      </div>
      <label class="list-input-title">添加物</label>
      <div class="list-input-content">
        <app-text-area id="txb_Additives" [subid]="'txb_Additives'" [restrict]="'[ -￮]'" [displayCountField]="true"
          [maxChars]="200" [tabindex]="0" [fullOnly]="true" [(ngModel)]="model.newGoodsProposal.additives"
          [disabled]="model.disabledSettings.additives" [counterWidth]="'75px'">
        </app-text-area>
      </div>
      <label class="list-input-title">調理方法</label>
      <div class="list-input-content">
        <app-text-area id="txtb_CookingMethod" [subid]="'txtb_CookingMethod'" [restrict]="'[ -￮]'"
          [displayCountField]="true" [maxChars]="2000" [tabindex]="0" [fullOnly]="true"
          [(ngModel)]="model.newGoodsProposal.cookingMethod" [disabled]="model.disabledSettings.cookingMethod"
          class="max-2000" [counterWidth]="'75px'">
        </app-text-area>
      </div>
      <label class="list-input-title">MOB登録有無</label>
      <div class="list-input-content">
        <label><input type="checkbox" id="chk_MobRegistered" [(ngModel)]="model.newGoodsProposal.mobRegistered" [tabindex]="0"
          [disabled]="model.disabledSettings.mobRegistered"/>有</label>
      </div>
      <label class="list-input-title">撮影希望時の指示</label>
      <div class="list-input-content">
        <app-text-area id="txb_ShootingInstruction" [subid]="'txb_ShootingInstruction'" [restrict]="'[ -￮]'"
          [displayCountField]="true" [maxChars]="200" [tabindex]="0" [fullOnly]="true"
          [(ngModel)]="model.newGoodsProposal.shootingInstruction" [disabled]="model.disabledSettings.shootingInstruction"
          [counterWidth]="'75px'">
        </app-text-area>
      </div>
      <label class="list-input-title">イメージ写真</label>
      <div class="list-input-content element-row">
        <button id="btn_UploadImage" class="btn-secondary" (click)="eventUploadImage_CLICKHandler()"
          [style.width.px]="100" [disabled]="model.disabledSettings.uploadImage">添付</button>
        <input type="text" [style.width.rem]="20" id="txti_ImageFileName" [(ngModel)]="model.newGoodsProposal.imageFileName" readonly />
        <button id="btn_OutputImage" class="btn-secondary" (click)="eventOutputImage_CLICKHandler()"
          [style.width.px]="100"
          [disabled]="!model.newGoodsProposal.imageFileName">出力</button>
      </div>
      <label class="list-input-title">撮影イメージ</label>
      <div class="list-input-content">
        <app-text-area id="txb_ShootingImage" [subid]="'txb_ShootingImage'" [restrict]="'[ -￮]'"
          [displayCountField]="true" [maxChars]="200" [tabindex]="0" [fullOnly]="true"
          [(ngModel)]="model.newGoodsProposal.shootingImage" [disabled]="model.disabledSettings.shootingImage"
          [counterWidth]="'75px'">
        </app-text-area>
      </div>
      <label class="list-input-title">備考</label>
      <div class="list-input-content">
        <app-text-area id="txb_Note" [subid]="'txb_Note'" [restrict]="'[ -￮]'" [displayCountField]="true"
          [maxChars]="2000" [tabindex]="0" [fullOnly]="true" [(ngModel)]="model.newGoodsProposal.note"
          [disabled]="model.disabledSettings.note" class="max-2000" [counterWidth]="'75px'">
        </app-text-area>
      </div>
      <label class="list-input-title">予測点数</label>
      <div class="list-input-content">
        <input type="text" id="txti_PredictedPoints" [maxlength]="5" [tabindex]="0" plessInputTextSub
          [restrict]="'[0-9]'" [(ngModel)]="model.newGoodsProposal.predictedPoints" [style.width.rem]="5"
          [disabled]="model.disabledSettings.predictedPoints" />
      </div>
      <ng-container *ngIf="model.isDisplayRejectedReason()">
        <label class="list-input-title">不採用理由</label>
        <div class="list-input-content">
          <app-text-area id="txta_RejectedReason" [subid]="'txta_rejectedReason'" [restrict]="'[ -￮]'"
            [displayCountField]="true" [maxChars]="200" [tabindex]="0" [fullOnly]="true"
            [(ngModel)]="model.newGoodsProposal.rejectedReason" [disabled]="model.disabledSettings.rejectedReason"
            [counterWidth]="'75px'">
          </app-text-area>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-container *ngIf="model.isBeforeProposing()">
    <div class="button-group element-row">
      <button id="btn_Save" class="btn-secondary" (click)="eventSave_CLICKHandler()">一時保存</button>
      <button id="btn_Proposal" class="btn-primary" (click)="eventProposal_CLICKHandler()">提案</button>
    </div>
  </ng-container>
  <ng-container *ngIf="model.isBuyerEditable()">
    <div class="layout_balance">
      <button id="btn_Reject" class="btn-tartiary" (click)="eventBuyerReject_CLICKHandler()" style="width: 150px;">不採用</button>
      <button id="btn_Approve" class="btn-primary" (click)="eventBuyerApprove_CLICKHandler()">採用</button>
    </div>
  </ng-container>
</div>